import { SettingStatePart } from '../../setup/types';

export const getSettings = (state: SettingStatePart) => state.settings.settings;
